import styled from 'styled-components';
import { media } from '@core/styles/breakpoints';
import { slate1 } from '@engage/colors/base';
import { spaces } from '@engage/styles/spaces';
import LoadingSpinner from '@members/loading/LoadingSpinner';

export const Loading = styled(LoadingSpinner)`
  display: ${props => (props.isLoading ? 'block' : 'none')};
  fill: ${slate1};
  margin: auto;
  margin-bottom: 140px;
  margin-top: ${spaces.huge}px;
  ${media.tablet`
    margin-bottom: 200px;
  `}
`;
